<template>
  <div class="role-targeting border rounded p-3">
    <div class="form-check mb-2">
      <input
        :id="`${idPrefix}-all-roles`"
        class="form-check-input"
        type="checkbox"
        :checked="modelValue.apply_to_all_roles"
        @change="onAllRolesChange"
      />
      <label class="form-check-label" :for="`${idPrefix}-all-roles`">
        Todos los roles de cliente
      </label>
    </div>
    <div v-if="!modelValue.apply_to_all_roles">
      <label class="form-label mb-1">Roles permitidos</label>
      <div class="d-flex flex-wrap gap-2">
        <label v-for="r in roles" :key="r.id" class="form-check form-check-inline mb-0">
          <input
            class="form-check-input"
            type="checkbox"
            :checked="(modelValue.role_ids || []).includes(r.id)"
            @change="toggleRole(r.id, $event.target.checked)"
          />
          <span class="form-check-label">{{ r.label }}</span>
        </label>
      </div>
    </div>
  </div>
</template>

<script setup>
import {  defineProps, defineEmits } from 'vue'
const props = defineProps({
  modelValue: { type: Object, required: true },
  roles: { type: Array, default: () => [] },
  idPrefix: { type: String, default: 'role' },
})

const emit = defineEmits(['update:modelValue'])

const onAllRolesChange = (event) => {
  const checked = event.target.checked
  emit('update:modelValue', {
    ...props.modelValue,
    apply_to_all_roles: checked,
    role_ids: checked ? [] : (props.modelValue.role_ids || []),
  })
}

const toggleRole = (roleId, checked) => {
  const current = [...(props.modelValue.role_ids || [])]
  const next = checked ? [...current, roleId] : current.filter(id => id !== roleId)
  emit('update:modelValue', { ...props.modelValue, role_ids: next })
}
</script>

<style scoped>
.role-targeting {
  border-color: var(--panel-border) !important;
  background: rgba(0, 0, 0, 0.15);
}
.form-label {
  color: rgba(255, 255, 255, 0.85);
  font-size: 0.85rem;
}
</style>
